// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { isSNJ } from '@tcp/core/src/utils/utils';
import { isCanada, routerPush } from '@tcp/core/src/utils';
import { COUPON_REDEMPTION_TYPE } from '@tcp/core/src/services/abstractors/CnC/CartItemTile';
import internalEndpoints from '../../../internalEndpoints';
import withStyles from '../../../../../../common/hoc/withStyles';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import Col from '../../../../../../common/atoms/Col';
import Row from '../../../../../../common/atoms/Row';
import CouponDetailModal from '../../../../../CnC/common/organism/CouponAndPromos/views/CouponDetailModal.view';
import CouponHelpModal from '../../../../../CnC/common/organism/CouponAndPromos/views/CouponHelpModal.view';
import OffersCarouselView from './components/OffersCarouselView';
import styles from '../styles/MyOffersCoupons.view.style';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import AccountCommonLabels, {
  ACCOUNT_LABELS,
  CHECKOUT_LABELS,
  GLOBAL_LABELS,
} from '../../../labels/AccountCommon.labels';

class MyOffersCouponView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      detailStatus: false,
      selectedCoupon: {},
      couponWithHoldingLegalText: null,
    };
    this.checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, AccountCommonLabels);
    this.globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);
    this.accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);
  }

  componentDidUpdate(prevProps) {
    const { allCouponList } = this.props;
    const prevCouponsList = prevProps.allCouponList;
    if (allCouponList !== prevCouponsList && this.state.selectedCoupon !== null) {
      allCouponList.forEach((cpn) => {
        if (cpn.id === this.state.selectedCoupon.id)
          this.setState({ couponWithHoldingLegalText: cpn });
      });
    }
  }

  /**
   * This function will handle click to open coupon detail modal
   * @param {} -
   */
  couponDetailClick = (coupon) => {
    const { fetchCouponTermsAndConditions, isAccountDashboard } = this.props;

    const payload = { ...coupon, isAccountDashboard };
    if (!coupon.legalText && coupon.promotionId) fetchCouponTermsAndConditions(payload);
    this.setState({
      detailStatus: true,
      selectedCoupon: coupon,
    });
  };

  /**
   * This function will handle click to open help detail modal
   * @param {} -
   */
  toggleCouponNeedHelpModal = () => {
    const { toggleNeedHelpModal } = this.props;
    toggleNeedHelpModal();
  };

  /**
   * This function will handle click to go to wallet Page
   * @param {} -
   */
  goToWalletPage = () => {
    const { closedOverlay } = this.props;
    routerPush(internalEndpoints.myWalletPage.link, internalEndpoints.myWalletPage.path);
    closedOverlay();
  };

  handleShopNowClick = (e) => {
    e.preventDefault();
    const { closedOverlay } = this.props;
    routerPush(internalEndpoints.shopNowPage.link, internalEndpoints.shopNowPage.path);
    closedOverlay();
  };

  getCouponList = () => {
    const { allCouponList, isPlacePerkEnabled, isPlacePerks } = this.props;
    let couponList = allCouponList;
    if (isPlacePerkEnabled && isPlacePerks) {
      couponList = allCouponList?.filter((coupon) => {
        return coupon.offerType === COUPON_REDEMPTION_TYPE.PLACEPERKS;
      });
    }

    return couponList;
  };

  getCouponTitle = () => {
    const { isUserLoggedIn } = this.props;
    const isCA = isCanada();
    if (isCA) {
      return renderLabel(
        this.globalLabels?.placeRewards?.lbl_my_coupon_title,
        'lbl_my_coupon_title'
      )?.toUpperCase();
    }
    if (isUserLoggedIn) {
      return renderLabel(
        this.globalLabels?.accountDrawer?.lbl_rewardsAndOffers_recent_rewards,
        'lbl_rewardsAndOffers_recent_rewards'
      );
    }
    return renderLabel(
      this.checkoutLabels?.bagPage?.lbl_coupon_collapsible_header,
      'lbl_coupon_collapsible_header'
    )?.toUpperCase();
  };

  renderOfferCouponHeading() {
    const { couponSelfHelp, isAccountDrawer, isUserLoggedIn } = this.props;
    const couponList = this.getCouponList();
    const couponListSize = couponList && couponList.size;
    const hidePlaceHelpLink = isSNJ();
    const isCA = isCanada();
    const couponDescription = isCA
      ? renderLabel(
          this.globalLabels?.placeRewards?.lbl_my_rewards_emptySupportingText,
          'lbl_my_rewards_emptySupportingText'
        )
      : renderLabel(
          this.globalLabels?.accountDrawer?.lbl_rewardsAndOffers_start_shopping,
          'lbl_rewardsAndOffers_start_shopping'
        );
    return isAccountDrawer ? (
      <>
        <div className="rewards-and-offers-section">
          <div className="">
            <div className="rewards-offers-header alignCenter">
              <BodyCopy fontFamily="secondary" fontWeight="bold" fontSize="fs16">
                {this.getCouponTitle()}
              </BodyCopy>
            </div>
            {couponListSize === 0 && isUserLoggedIn && (
              <div className="rewards-offers-content alignCenter">
                <Anchor
                  fontFamily="secondary"
                  href="#"
                  fontSize="fs16"
                  anchorVariation="primary"
                  text={couponDescription}
                  onClick={(e) => this.handleShopNowClick(e)}
                  underline
                />
              </div>
            )}
            {!isUserLoggedIn && (
              <div className="rewards-offers-content alignCenter">
                <Anchor
                  fontFamily="secondary"
                  href="#"
                  fontSize="fs16"
                  anchorVariation="primary"
                  text={`${renderLabel(
                    this.globalLabels?.accountDrawer?.lbl_accountDrawer_rememberUser,
                    'lbl_accountDrawer_rememberUser'
                  )}`}
                  underline
                  onClick={this.goToWalletPage}
                  to={internalEndpoints.myWalletPage.link}
                  asPath={internalEndpoints.myWalletPage.path}
                />
              </div>
            )}
          </div>
        </div>
      </>
    ) : (
      <BodyCopy component="div" className="couponList_title">
        <Row fullBleed>
          <Col
            colSize={{
              small: 4,
              medium: 6,
              large: 9,
            }}
            className="couponList_title_text"
          >
            <BodyCopy
              className="couponList_heading"
              fontWeight="semibold"
              component="p"
              fontSize="fs16"
              data-locator="sdf"
              fontFamily="secondary"
            >
              {`${getDynamicLabelValues(
                'dynamic.global_d.lbl_my_rewards_drawerHeading'
              )} (${couponListSize})`}
            </BodyCopy>
          </Col>
          <Col
            colSize={{
              small: 2,
              medium: 2,
              large: 3,
            }}
          >
            {couponListSize > 0 && !couponSelfHelp && (
              <BodyCopy className="view_all" component="div" textAlign="right">
                <Anchor
                  fontSizeVariation="medium"
                  underline
                  anchorVariation="primary"
                  fontSize="fs13"
                  fontFamily="secondary"
                  dataLocator="couponcard-view_all"
                  textAlign="right"
                  onClick={this.goToWalletPage}
                  to={internalEndpoints.myWalletPage.link}
                  asPath={internalEndpoints.myWalletPage.path}
                >
                  {renderLabel(
                    this.globalLabels?.placeRewards?.lbl_my_rewards_viewAll,
                    'lbl_my_rewards_viewAll'
                  )}
                </Anchor>
              </BodyCopy>
            )}
          </Col>
        </Row>
        {couponListSize > 0 && !couponSelfHelp && !hidePlaceHelpLink && (
          <BodyCopy component="div" className="couponList_iconContainer">
            <BodyCopy component="div" className="couponList_helpIcon">
              ?
            </BodyCopy>
            <Anchor
              fontSizeVariation="small"
              underline
              anchorVariation="primary"
              fontSize="fs10"
              fontFamily="secondary"
              dataLocator="couponcard-helpApplyingPlaceCashlink"
              onClick={this.toggleCouponNeedHelpModal}
            >
              {renderLabel(
                this.globalLabels?.placeRewards?.lbl_my_rewards_helpLink,
                'lbl_my_rewards_helpLink'
              )}
            </Anchor>
          </BodyCopy>
        )}
      </BodyCopy>
    );
  }

  renderViewAllOffersLink() {
    const { isAccountDrawer } = this.props;
    const couponList = this.getCouponList();
    const couponListSize = couponList && couponList.size;
    return isAccountDrawer && couponListSize !== 0 ? (
      <>
        <BodyCopy component="div" className="view-all-offers-link-wrapper">
          <Anchor
            to={internalEndpoints.myWalletPage.link}
            asPath={internalEndpoints.myWalletPage.path}
            className="view-all-offers-link"
            target="_self"
            dataLocator="coupon_view_all_offers_link"
            onClick={this.goToWalletPage}
            fontFamily="secondary"
            fontSize="fs14"
            fontSizeVariation="medium"
            underline
          >
            {renderLabel(this.globalLabels?.cartItemTile?.lbl_view_all, 'lbl_view_all')}
          </Anchor>
        </BodyCopy>
      </>
    ) : null;
  }

  renderDivider() {
    const { isAccountDrawer, isAccountDashboard } = this.props;
    const isCA = isCanada();
    const couponList = this.getCouponList();
    const couponListSize = couponList && couponList.size;

    return (
      (isAccountDashboard && !isCA && couponListSize !== 0) ||
      (isAccountDrawer && !isCA && couponListSize !== 0 && <div className="divider" />)
    );
  }

  renderViewAllLink = (linkClassName) => {
    return (
      <Anchor
        to={internalEndpoints.myWalletPage.link}
        asPath={internalEndpoints.myWalletPage.path}
        className={`${linkClassName}`}
        target="_self"
        dataLocator="place_perks_coupon_view_all_link"
        onClick={this.goToWalletPage}
        fontFamily="secondary"
        fontSizeVariation="xlarge"
        underline
      >
        {renderLabel(this.globalLabels?.cartItemTile?.lbl_view_all, 'lbl_view_all')}
      </Anchor>
    );
  };

  renderPlacePerksViewAll = () => {
    const { isPlacePerkEnabled, isPlacePerks, fromPlaceRewards } = this.props;
    const couponList = this.getCouponList();
    const couponListSize = couponList && couponList.size;

    return (
      isPlacePerkEnabled &&
      isPlacePerks &&
      couponListSize !== 0 &&
      fromPlaceRewards &&
      this.renderViewAllLink('view-all-place-perks-bottom-link')
    );
  };

  renderPlacePerksHeading = () => {
    const couponList = this.getCouponList();
    const couponListSize = couponList && couponList.size;

    return (
      couponListSize !== 0 && (
        <div className="place-perks-title cards-title">
          {renderLabel(
            this.accountLabels?.accountOverview?.lbl_placeperk_my_perk,
            'lbl_placeperk_my_perk'
          )}

          {this.renderViewAllLink('view-all-place-perks-link')}
        </div>
      )
    );
  };

  renderBonusPointsDayHeading = (bonusPointDayData) => {
    return (
      bonusPointDayData?.availableBPD > 0 && (
        <div className="bonus-points-title cards-title">
          {renderLabel(
            this.accountLabels?.accountOverview?.lbl_bonus_points_heading,
            'lbl_bonus_points_heading'
          )}
        </div>
      )
    );
  };

  render() {
    const {
      labels,
      handleApplyCouponFromList,
      className,
      isNeedHelpModalOpen,
      isAccountDrawer,
      isPlacePerkEnabled,
      isPlacePerks,
      isCartPageCouponSection,
      isWallet,
      bonusPointDayData,
      fromPlaceRewards,
      isBonusPointDayEnabled,
      variation,
      isCouponSmoothScrollEnabled,
      currentPerkLevel,
      displayCards,
      isMPRAndCSHCouponRedesignEnabled,
      isFromMPRPage,
      setBonusPointDayCouponIndexAction,
      fromBagPage,
      fromIsApplyAction,
      fromApplyCTA,
      multiUseCouponList,
      isNewCouponUXWithoutTabEnabled,
      isFromBagPage,
      isLoyaltyTieringEnabled,
      isCheckout,
      totalPriceOfAllLicensedProducts,
      isNewAccountDrawer,
    } = this.props;
    const { detailStatus, selectedCoupon, couponWithHoldingLegalText } = this.state;
    const detailedCoupon =
      couponWithHoldingLegalText !== null ? couponWithHoldingLegalText : selectedCoupon;
    const perkClassName = isPlacePerkEnabled && isPlacePerks ? 'place-perks-coupons-wrapper' : '';
    return (
      <>
        <Row className={`${className} ${perkClassName}`}>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            {!isCartPageCouponSection && isAccountDrawer && this.renderOfferCouponHeading()}
            {!isCartPageCouponSection &&
              isPlacePerkEnabled &&
              isPlacePerks &&
              !fromPlaceRewards &&
              this.renderPlacePerksHeading()}
            {fromPlaceRewards && this.renderBonusPointsDayHeading(bonusPointDayData)}
            <OffersCarouselView
              {...this.props}
              couponDetailClick={this.couponDetailClick}
              goToWalletPage={this.goToWalletPage}
              isWallet={isWallet}
              bonusPointDayData={bonusPointDayData}
              fromPlaceRewards={fromPlaceRewards}
              isBonusPointDayEnabled={isBonusPointDayEnabled}
              variation={variation}
              isCouponSmoothScrollEnabled={isCouponSmoothScrollEnabled}
              currentPerkLevel={currentPerkLevel}
              displayCards={displayCards}
              isMPRAndCSHCouponRedesignEnabled={isMPRAndCSHCouponRedesignEnabled}
              isFromMPRPage={isFromMPRPage}
              setBonusPointDayCouponIndexAction={setBonusPointDayCouponIndexAction}
              fromBagPage={fromBagPage}
              fromIsApplyAction={fromIsApplyAction}
              fromApplyCTA={fromApplyCTA}
              isNewCouponUXWithoutTabEnabled={isNewCouponUXWithoutTabEnabled}
              isFromBagPage={isFromBagPage}
              isLoyaltyTieringEnabled={isLoyaltyTieringEnabled}
              isCheckout={isCheckout}
              totalPriceOfAllLicensedProducts={totalPriceOfAllLicensedProducts}
              isNewAccountDrawer={isNewAccountDrawer}
            />
            {!isCartPageCouponSection && this.renderViewAllOffersLink()}
            {!isCartPageCouponSection && !fromPlaceRewards && this.renderPlacePerksViewAll()}
          </Col>
        </Row>
        {this.renderDivider()}
        <CouponDetailModal
          openState={detailStatus}
          coupon={detailedCoupon}
          onRequestClose={() => {
            this.setState({
              detailStatus: false,
              couponWithHoldingLegalText: null,
              selectedCoupon: null,
            });
          }}
          multiUseCouponList={multiUseCouponList}
          onApplyCouponToBagFromList={handleApplyCouponFromList}
        />
        <CouponHelpModal
          labels={labels}
          openState={isNeedHelpModalOpen}
          coupon={detailedCoupon}
          onRequestClose={() => {
            this.toggleCouponNeedHelpModal();
          }}
          heading="Help Modal"
        />
      </>
    );
  }
}

MyOffersCouponView.propTypes = {
  labels: PropTypes.shape({}).isRequired,
  isFetching: PropTypes.bool.isRequired,
  handleRemoveCoupon: PropTypes.func.isRequired,
  closedOverlay: PropTypes.func,
  handleErrorCoupon: PropTypes.func.isRequired,
  allCouponList: PropTypes.shape([]).isRequired,
  className: PropTypes.string,
  isCarouselView: PropTypes.bool,
  sliceCount: PropTypes.number,
  handleApplyCouponFromList: PropTypes.func.isRequired,
  toggleNeedHelpModal: PropTypes.func.isRequired,
  isNeedHelpModalOpen: PropTypes.bool.isRequired,
  couponSelfHelp: PropTypes.bool,
  isAccountDrawer: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
  isAccountDashboard: PropTypes.bool,
  isPlacePerks: PropTypes.bool,
  isPlacePerkEnabled: PropTypes.bool,
  autoApplyPerkCouponType: PropTypes.string,
  isLoyaltyTieringEnabled: PropTypes.bool.isRequired,
  isNewAccountDrawer: PropTypes.bool,
};

MyOffersCouponView.defaultProps = {
  closedOverlay: () => {},
  className: '',
  isCarouselView: false,
  sliceCount: 10,
  couponSelfHelp: false,
  isAccountDrawer: false,
  isUserLoggedIn: false,
  isAccountDashboard: false,
  isPlacePerks: false,
  isPlacePerkEnabled: false,
  autoApplyPerkCouponType: '',
  isNewAccountDrawer: false,
};

export default withStyles(MyOffersCouponView, styles);
export { MyOffersCouponView as MyOffersCouponViewVanilla };
